export default __webpack_public_path__ + "static/media/formato-de-devolución-de-impuestos-estatales.91b9d24f.pdf";